import React from "react";

export default function Stepper({ onClick, steps, current = 0 }) {
    return (
        <div className="k-stepper">
            <div className="k-stepper__wrap">
                {steps.map((label, i) => {
                    const state =
                        i < current ? "completed" : i === current ? "active" : "idle";

                    return (
                        <React.Fragment key={label}>
                            <div className="k-stepper__step">
                                <div className={`k-stepper__circleWrap is-${state}`}>
                                    <div className="k-stepper__circle">
                                        <span className="k-stepper__dot" />
                                    </div>
                                </div>

                                <div className="k-stepper__label">{label}</div>
                            </div>
                            {i < steps.length - 1 ? (
                                <div
                                    className={`k-stepper__connector ${i < current ? "is-completed" : ""}`}
                                    aria-hidden="true"
                                />
                            ) : null}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}
